let csrfToken = ``;
export const SESSION_ACTIVITY_EVENT = `opat:session-activity`;
export const SESSION_EXPIRED_EVENT = `opat:session-expired`;
export const MUTATION_RESULT_EVENT = `opat:mutation-result`;

export function setCsrfToken(value) {
  csrfToken = value;
}

const emit = (name, detail = {}) => globalThis.dispatchEvent?.(new CustomEvent(name, { detail }));

export async function refreshSession({ renew = true } = {}) {
  const action = renew ? `session` : `session-status`;
  const response = await fetch(`/api/auth.php?action=${action}`, { credentials: `same-origin`, headers: { Accept: `application/json` } });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || !data.authenticated || !data.user?.csrf) {
    emit(SESSION_EXPIRED_EVENT, { status: response.status });
    return { ok: false, response, data };
  }
  setCsrfToken(data.user.csrf);
  if (renew) emit(SESSION_ACTIVITY_EVENT, { at: Date.now(), expiresAt: data.user.sessionExpiresAt, absoluteExpiresAt: data.user.absoluteExpiresAt });
  return { ok: true, response, data };
}

export async function apiFetch(url, options = {}) {
  const response = await fetch(url, {
    ...options,
    credentials: `same-origin`,
    headers: {
      ...(options.headers || {}),
      ...(options.method && options.method !== `GET`
        ? { "X-CSRF-Token": csrfToken }
        : {}),
    },
  });
  if (response.status === 401) emit(SESSION_EXPIRED_EVENT, { status: 401 });
  else emit(SESSION_ACTIVITY_EVENT, { at: Date.now() });
  if (options.method && options.method !== `GET`) emit(MUTATION_RESULT_EVENT, { ok: response.ok, status: response.status });
  return response;
}
